import { User } from "../../../core/internal/model/model"
import { UserContext } from "../../../core/internal/user/UserContext"
import { UserCohorts } from "../../../core/internal/user/UserCohort"
import { UserTargets } from "../../../core/internal/user/UserTarget"

/**
 * Local-mode user context: the user plus the cohorts and target events resolved for on-device
 * evaluation. Cohorts are always filtered by the current user's identifiers.
 */
export class LocalUserContext implements UserContext {
  private constructor(readonly user: User, readonly cohorts: UserCohorts, readonly targetEvents: UserTargets) {}

  static of(user: User, cohort: UserCohorts, targetEvents: UserTargets): LocalUserContext {
    return new LocalUserContext(user, cohort.filterBy(user), targetEvents)
  }

  with(user: User): LocalUserContext {
    return LocalUserContext.of(user, this.cohorts.filterBy(user), this.targetEvents)
  }

  update(cohorts: UserCohorts, targetEvents: UserTargets): LocalUserContext {
    const filtered = cohorts.filterBy(this.user)
    const newCohorts = this.cohorts.toBuilder().putAll(filtered).build()
    return LocalUserContext.of(this.user, newCohorts, targetEvents)
  }
}
